// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"G3-z","displaySixCardTiles":"H3-z"};